import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getRoles, patchExistingRole, postNewRole, removeRole } from './data';
import { errorReceiveCreateRole, errorReceiveModifyRole, errorReceiveRemoveRole, errorReceiveRoles, failedReceiveCreateRole, failedReceiveModifyRole, failedReceiveRemoveRole, failedReceiveRoles, receiveCreateRole, receiveModifyRole, receiveRemoveRole, receiveRoles } from './slice';
export function* requestCreateRole(action) {
    try {
        const { consumerAPI, newRole } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postNewRole, organization, newRole, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveCreateRole());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_ROLE', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveCreateRole());
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_ROLE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_ROLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveCreateRole());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_ROLE', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveCreateRole());
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_ROLE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_ROLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveCreateRole());
    }
}
export function* requestModifyRole(action) {
    try {
        const { consumerAPI, roleId, update } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchExistingRole, organization, roleId, update, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveModifyRole());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_ROLE', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveModifyRole(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_ROLE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_ROLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveModifyRole());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_ROLE', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveModifyRole(response.data, true));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_ROLE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_ROLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveModifyRole());
    }
}
export function* requestRemoveRole(action) {
    try {
        const { consumerAPI, roleId } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(removeRole, organization, roleId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveRemoveRole());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_ROLE', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveRemoveRole(roleId));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_ROLE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_ROLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 204) {
                yield put(errorReceiveRemoveRole());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_ROLE', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 204) {
                yield put(receiveRemoveRole(roleId, true));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_ROLE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_ROLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveRole());
    }
}
export function* requestRoles(action) {
    try {
        const { consumerAPI } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getRoles, organization, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveRoles());
            }
            else if (data) {
                yield put(receiveRoles(data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_ROLES', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveRoles());
            }
            else if (response && response.status === 200) {
                yield put(receiveRoles(response.data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_ROLES', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveRoles());
    }
}
export function* watchRequestCreateRole() {
    yield takeLatest('roles/requestCreateRole', requestCreateRole);
}
export function* watchRequestModifyRole() {
    yield takeLatest('roles/requestModifyRole', requestModifyRole);
}
export function* watchRequestRemoveRole() {
    yield takeLatest('roles/requestRemoveRole', requestRemoveRole);
}
export function* watchRequestRoles() {
    yield takeLatest('roles/requestRoles', requestRoles);
}
